import { createSlice } from "@reduxjs/toolkit";

export const ordersSlice = createSlice({
    name: "orders",
    initialState: [],
    reducers: {
        placeOrder: (state, action) => {

            const order = {
                items: action.payload,
                datePlaced: new Date().toUTCString(),
            }

            return [...state, order]
        }
    }
});

export const {
    placeOrder
} = ordersSlice.actions;

export default ordersSlice.reducer;



